__turbopack_context__.v({
  "nameText": "IssueHeader-module__DMIunq__nameText",
  "onText": "IssueHeader-module__DMIunq__onText",
  "swayScoreButton": "IssueHeader-module__DMIunq__swayScoreButton",
  "topicText": "IssueHeader-module__DMIunq__topicText",
  "voteHeader": "IssueHeader-module__DMIunq__voteHeader",
  "voteTitle": "IssueHeader-module__DMIunq__voteTitle",
  "voteWithText": "IssueHeader-module__DMIunq__voteWithText",
});
